// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Belt_List from "bs-platform/lib/es6/belt_List.js";

function range(start, end_) {
  if (start >= end_) {
    return /* [] */0;
  } else {
    return {
            hd: start,
            tl: range(start + 1 | 0, end_)
          };
  }
}

function cartesian(l1, l2) {
  return Belt_List.flatten(Belt_List.map(l1, (function (e) {
                    return Belt_List.map(l2, (function (e$prime) {
                                  return [
                                          e,
                                          e$prime
                                        ];
                                }));
                  })));
}

function take(n, lst) {
  var taken = Belt_List.take(lst, n);
  if (taken !== undefined) {
    return taken;
  } else {
    return lst;
  }
}

var List;

var shuffle = Belt_List.shuffle;

export {
  List ,
  range ,
  cartesian ,
  shuffle ,
  take ,
  
}
/* No side effect */
